import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SupportCenterPageRoutingModule } from './support-center-routing.module';

import { SupportCenterPage } from './support-center.page';
import { SharedModule } from '@shared/shared.module';
import { SupportCenterCardComponent } from './components/support-center-card/support-center-card.component';
import { SupportCenterStatusComponent } from './components/support-center-status/support-center-status.component';
import { EffectsModule } from '@ngrx/effects';
import { supportCenterEffects } from './effects/support-center.effects';
import { SupportCenterModalComponent } from './components/support-center-modal/support-center-modal.component';
import { HeaderTileComponent } from './components/header-tile/header-tile.component';
import { SupportRequestModalComponent } from './components/support-request-modal/support-request-modal.component';
import { AcceptedFileTypesPopoverComponent } from '@service-request/pages/request-credit/components/accepted-file-types-popover/accepted-file-types-popover.component';
import { RequestCreditPageModule } from '@service-request/pages/request-credit/request-credit.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    SupportCenterPageRoutingModule,
    RequestCreditPageModule,
    EffectsModule.forFeature([supportCenterEffects]),
  ],
  declarations: [
    SupportCenterPage,
    SupportCenterCardComponent,
    SupportCenterStatusComponent,
    SupportCenterModalComponent,
    HeaderTileComponent,
    SupportRequestModalComponent,
  ],
})
export class SupportCenterPageModule {}
